<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      

	  <div class="backborder2 shop-sale-table" style="margin-top:10px" v-loading="statquery.loading">
	    <span class="shop-sales-title">商品信息</span>
		<table>
			<tr>
				<td class="shoptitle" align="center" width="25%">商品名称</td>
				<td class="shoptitle" align="center" width="25%">品牌</td>
				<td class="shoptitle" align="center" width="25%">规格型号/在售单位</td>
				<td class="shoptitle" align="center" width="25%">重量</td>								
			</tr>
			<tr>
				<td align="center">{{statinfos.name}}</td>
				<td align="center">{{statinfos.brandname}}</td>
				<td align="center">{{statinfos.spec}} / {{statinfos.unit}}</td>
				<td align="center">{{statinfos.weight}} kg</td>	
			</tr>
			<tr>
				<td class="shoptitle" align="center" width="25%">商品售价</td>
				<td class="shoptitle" align="center" width="25%">一键代发价</td>
				<td class="shoptitle" align="center" width="25%">采购次数</td>
				<td class="shoptitle" align="center" width="25%">销售数量</td>
			</tr>
			<tr>
				<td align="center">￥{{statinfos.propertyprice}}</td>
				<td align="center">￥{{statinfos.replaceprice}}</td>
				<td align="center">{{statinfos.orders}}</td>
				<td align="center">{{statinfos.numbers}}</td>	
			</tr>
			<tr>
				<td class="shoptitle" align="center" width="25%">实付金额</td>
				<td class="shoptitle" align="center" width="25%">销售成本</td>
				<td class="shoptitle" align="center" width="25%">销售利润</td>
				<td class="shoptitle" align="center" width="25%">商品状态</td>		
			</tr>
			<tr>
				<td align="center">￥{{statinfos.prices}}</td>
				<td align="center">￥{{statinfos.costs}}</td>
				<td align="center">￥{{statinfos.profits}}</td>
				<td align="center">{{statinfos.status}}</td>	
			</tr>
			<tr>
				<td class="shoptitle" align="center" width="25%">运费模板</td>
				<td class="shoptitle" align="center" width="25%"></td>
				<td class="shoptitle" align="center" width="25%"></td>
				<td class="shoptitle" align="center" width="25%"></td>		
			</tr>
			<tr>
				<td align="center">
					<el-select size="small" v-model="statinfos.shipping_tempid" remote  filterable placeholder="请选择运费模板" @change="settinggoodsshipping">	            
						<el-option v-for="(item,index) in shippingtemplists" :label="item.name" :value="item.id" :key="index" />            
					</el-select>  
				</td>
				<td align="center"></td>
				<td align="center"></td>
				<td align="center"></td>	
			</tr>
		</table>
	  </div>

	  

	  <div class="backborder2 shop-sale-table" style="margin-top:10px;margin-bottom:20px" v-loading="orderlogisticsquery.loading">
	      <span class="shop-sales-title">历史订单记录</span>
		  <table>
			<tr>
				<td class="shoptitle" align="center">订单号</td>
				<td class="shoptitle" align="center">订单金额</td>
				<td class="shoptitle" align="center">实付金额</td>
				<td class="shoptitle" align="center">支付方式</td>
				<td class="shoptitle" align="center">收货人</td>
				<td class="shoptitle" align="center">联系电话</td>
				<td class="shoptitle" align="center">下单时间</td>
				<td class="shoptitle" align="center">订单状态</td>	
			</tr>
			<tr v-for="(item,index) in orderlogisticslists" :key="index">
				<td align="center">{{item.ordernumber}}</td>
				<td align="center">{{item.totals}}</td>
				<td align="center">{{item.prices}}</td>
				<td align="center">{{item.paytype}}</td>
				<td align="center">{{item.truename}}</td>
				<td align="center">{{item.phone}}</td>
				<td align="center">{{item.time}}</td>
				<td align="center">{{item.status}}</td>	
			</tr>
		  </table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="orderlogpageSizeChange"
	              @current-change="orderlogpageCurrentChange"
	              :current-page="orderlogisticsquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="orderlogisticsquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="order_row_totals">
	          </el-pagination>
	          <!--分页end-->
	      </div>
	  </div>



  </div>
  </transition>  
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"Goods/index",
        transitionshow:true,
        actionauth:'', //功能权限
		query: {
			act:'getshopbase',
			token:this.$cookies.get('token'),
			loading:false,
			shopid:this.childdata.id
		},
		shopinfos: {
			thumb:'',
			shopname:'',
			truename:'',
			phone:'',
			address:'',
			labellists:[],
		},
		statquery: {
			act:'getreplacetat',
			token:this.$cookies.get('token'),
			loading:false,
			id:this.childdata.propertyid
		},
		statinfos: {
			name:'',
			brandname:'',
			spec:'',
			unit:'',
			weight:'',
			propertyprice:'',
			replaceprice:'',
			orders:'',
			numbers:'',
			prices:'',
			costs:'',
			profits:'',
			status:'',
			shipping_tempid:'',
		},
		labelmanagerDialog:false,
		labelloading:false,
		allabellists:[],
		shopstatviewquery: {
			act:'getshopsalesview',
			shopid:this.childdata.id,
			token:this.$cookies.get('token'),
			loading:false,
			type:1,
			stime:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1),
			etime:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+12),
		},
		typelist:[
			{id:1,name:'采购金额'},
			{id:2,name:'采购数量'},
		],
		orderlogisticsquery: {
			act:'getreplaceallorders',
			token:this.$cookies.get('token'),
			id:this.childdata.propertyid,
			loading:false,
			p:1,
			rollpage:10
		},
		orderlogisticslists:[],
		order_row_totals:0,

		isrefundchange:false,
		refundlogDialog:false,
		refundlogquery: {
			act:'getrefundlog',
			token:this.$cookies.get('token'),
			type:1,
			shopid:this.childdata.id,
			loading:false,
			p:1,
			rollpage:10
		},
		refundlists:[],
		refund_total_rows:0,
		memberlogDialog:false,
		ismemberchange:false,
		memberlogquery: {
			act:'memberlog',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		memberloglists:[],
		member_total_rows:0,
		ordertypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按总消费金额'},
			{id:3,name:'按下单数量'},
			{id:4,name:'按客单价'},
		],
		sortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],
		goodstypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按下单次数'},
			{id:3,name:'按购买数量'},
			{id:4,name:'按购买总金额'},
		],
		goodssortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],
		brandtypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按下单次数'},
			{id:3,name:'按购买数量'},
			{id:4,name:'按购买总金额'},
		],
		brandsortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],

		goodslogDialog:false,
		isgoodschange:false,
		goodslogquery: {
			act:'goodssalestat',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		goodsloglists:[],
		goods_total_rows:0,

		brandlogDialog:false,
		isbrandchange:false,
		brandlogquery: {
			act:'brandsalestat',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		brandloglists:[],
		brand_total_rows:0,
		custnaoLoading:false,
		brand: {
          legend: {
			 data:['采购金额']
		  },
		  xAxis: {			  
			  type: 'category', // 还有其他的type，可以去官网喵两眼哦
			  data: [], // x轴数据
			  name: '', //x轴名称
			  nameTextStyle: { //x轴名称样式
			    fontWeight: 600,
			    fontSize: 18,
				width: 20,
			  }		  
		  },
		  yAxis: {
			  type: 'value',
			  name: '', //y轴名称
			  nameTextStyle: { //y轴名称样式
			    fontWeight: 600,
			    fontSize: 18
			  }    
		  },
		  tooltip: {
			  trigger: 'axis' //axis item none三个值
		  },
		  
		  series: [
			  {
			    name: '采购金额',
			    data: [],
			    type: 'bar',
				barGap: 0,
			    itemStyle : {
					normal : {
						color:'#E6A23C',
					}
				},
			  }
		  ]
        },

		shippingtemplists:[],

	}
  },

  components: {IEcharts},
  mounted(){    
    this.getactionauth();
	this.getshippingtemplists(); //获取运费模板信息
	this.getshopstats(); //获取店铺销售信息统计
	this.getshoplogisticsorders(); //获取店铺所有的下单记录
  },
  
  methods:{

	//获取功能权限
	getactionauth() {
		var data =this.$cookies.get('actionauth');
		data=JSON.parse(data);
		this.actionauth=data;
	},


	/** 设置一件代发商品模板信息 **/
	settinggoodsshipping() {
		var resource = this.$resource(this.url);
		resource.save({act:'setting_replace_goods_shippingtempid',token:this.$cookies.get('token'),id:this.statquery.id,shipping_tempid:this.statinfos.shipping_tempid}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.$message.success("修改运费模板成功");                     
			}
		}).catch((res) => {
				
		});

	},


	/** 获取运费模板信息 **/
	getshippingtemplists() {
		var resource = this.$resource(this.GLOBAL.domain+"Shippingarea/index");
		resource.save({act:'getshippingtemplistsnew',token:this.$cookies.get('token'),temptypelists:2,sort:1,p:1,rollpage:10000000}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.shippingtemploading=false;
			}else{
				this.shippingtemplists = JSON.parse(Base64.decode(res.data.Data));                      
			}
		}).catch((res) => {
				
		});
	},	



	/** 获取店铺销售信息统计 **/
	getshopstats() {
		this.statquery.loading=true;
		var resource = this.$resource(this.url);
        resource.query(this.statquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.statquery.loading=false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
				this.statinfos.name=result.name;
				this.statinfos.brandname=result.brandname;
				this.statinfos.spec=result.spec;
				this.statinfos.unit=result.unit;
				this.statinfos.weight=result.weight;
				this.statinfos.propertyprice=result.propertyprice;
				this.statinfos.replaceprice=result.replaceprice;
				this.statinfos.orders=result.orders;
				this.statinfos.numbers=result.numbers;
				this.statinfos.prices=result.prices;
				this.statinfos.costs=result.costs;
				this.statinfos.profits=result.profits;
				this.statinfos.status=result.status;
				this.statinfos.shipping_tempid=result.shipping_tempid;
				this.statquery.loading=false;
	        }
        }).catch((res) => {
            this.statquery.loading=false;
        });
	},

	/** 解绑店铺标签 **/
	dellabels(item,index) {
		this.query.loading=true;
		var resource = this.$resource(this.url);
		var shopids=[];
		shopids.push(this.query.shopid);
        resource.save({act:'editlabeltoshops',ids:shopids,labelid:item.id,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.query.loading=false;
	        }else{
	            this.query.loading=false;
				this.getshopbase();
	        }
        }).catch((res) => {
            this.query.loading=false;
        });
	},

	/** 设置标签 **/
	settinglabels() {
		this.labelmanagerDialog=true;
		this.labelloading=true;
		this.allabellists=[];
		var resource = this.$resource(this.url);
        resource.query({act:'getallshoplabels',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.labelloading=false;
	        }else{
	            this.allabellists = JSON.parse(Base64.decode(res.data.Data));
				var labelids=[];
				var _this=this;
				this.shopinfos.labellists.forEach(function(item,i) {labelids.push(item.id);});
				this.allabellists.forEach(function(item,i) {
					labelids.indexOf(item.id)==-1 ? item.isselect=0 : item.isselect=1;
				});
				this.labelloading=false;
	        }
        }).catch((res) => {
            this.labelloading=false;
        });
	},

	/** 选择、取消选择标签 **/
	selectordellabel(item,index) {
		var status=0;
		item.isselect==0 ? status=1 : status=0;
		this.allabellists[index].isselect=status;
		this.allabellists=JSON.parse(JSON.stringify(this.allabellists));
	},

	/** 店铺设置标签 **/
	saveeditlabels() {
		var ids=[];
		this.allabellists.forEach(function(item,index) {
			item.isselect==1 ? ids.push(item.id) : '';
		});
		var resource = this.$resource(this.url);
        resource.save({act:'shopsettinglabels',ids:ids,shopid:this.query.shopid,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.labelmanagerDialog=false;
				this.getshopbase();
	        }
        }).catch((res) => {
            
        });
	},

	/** 获取店铺所有历史下单记录 **/
	getshoplogisticsorders() {
		this.orderlogisticsquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.orderlogisticsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.orderlogisticsquery.loading=false;
	        }else{
				this.orderlogisticsquery.loading=false;
				this.orderlogisticslists=[];
				this.orderlogisticslists = JSON.parse(Base64.decode(res.data.Data));
				this.order_row_totals=parseInt(res.data.count);
	        }
        }).catch((res) => {
            this.orderlogisticsquery.loading=false;
        });
	},

	orderlogpageSizeChange(val) {
        this.orderlogisticsquery.rollpage = val;
        this.getshoplogisticsorders();
    },
    orderlogpageCurrentChange(val) {
        this.orderlogisticsquery.p = val;
        this.getshoplogisticsorders();
    },


	/** 查看退货记录 **/
	refundlogs() {
		this.refundlogDialog=true;
		this.refundlogquery.type=1;
		this.refundlogquery.p=1;
		this.refundlogquery.rollpage=10;
		this.getrefundlogs();
	},

	//查询退货记录
	getrefundlogs() {
		if(this.isrefundchange) {
			this.refundlogquery.p=1;
			this.refundlogquery.rollpage=10;
		}

		this.refundlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.refundlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.refundlogquery.loading=false;
	        }else{
				this.refundlogquery.loading=false;
				this.refundlists=[];
				this.refundlists = JSON.parse(Base64.decode(res.data.Data));
				this.refund_total_rows=parseInt(res.data.count);
				if(this.isrefundchange) this.isrefundchange=false;
	        }
        }).catch((res) => {
            this.refundlogquery.loading=false;
        });
	},

	refundlogpageSizeChange(val) {
        this.refundlogquery.rollpage = val;
        this.getshoplogisticsorders();
    },
    refundlogpageCurrentChange(val) {
        this.refundlogquery.p = val;
        this.getshoplogisticsorders();
    },

	changerefundlog() {
		this.isrefundchange=true;
		this.getrefundlogs();
	},


	/** 店铺成员下单统计 **/
	memberlogs() {
		this.memberlogDialog=true;
		this.memberlogquery.ordertype=1;
		this.memberlogquery.sort=2;
		this.memberlogquery.key='';
		this.memberlogquery.p=1;
		this.memberlogquery.rollpage=10;
		this.getmemberlogs();
	},

	getmemberlogs() {
		if(this.ismemberchange) {
			this.memberlogquery.p=1;
			this.memberlogquery.rollpage=10;
		}

		this.memberlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.memberlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.memberlogquery.loading=false;
	        }else{
				this.memberlogquery.loading=false;
				this.memberloglists=[];
				this.memberloglists = JSON.parse(Base64.decode(res.data.Data));
				this.member_total_rows=parseInt(res.data.count);
				if(this.ismemberchange) this.ismemberchange=false;
	        }
        }).catch((res) => {
            this.memberlogquery.loading=false;
        });
	},

	memberlogpageSizeChange(val) {
        this.memberlogquery.rollpage = val;
        this.getmemberlogs();
    },
    memberlogpageCurrentChange(val) {
        this.memberlogquery.p = val;
        this.getmemberlogs();
    },

	/** 获取商品采购统计 **/
	goodslogs() {
		this.goodslogDialog=true;
		this.goodslogquery.ordertype=1;
		this.goodslogquery.sort=2;
		this.goodslogquery.key='';
		this.goodslogquery.p=1;
		this.goodslogquery.rollpage=10;
		this.getgoodslogs();
	},

	getgoodslogs() {
		if(this.isgoodschange) {
			this.goodslogquery.p=1;
			this.goodslogquery.rollpage=10;
		}

		this.goodslogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.goodslogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.goodslogquery.loading=false;
	        }else{
				this.goodslogquery.loading=false;
				this.goodsloglists=[];
				this.goodsloglists = JSON.parse(Base64.decode(res.data.Data));
				this.goods_total_rows=parseInt(res.data.count);
				if(this.isgoodschange) this.isgoodschange=false;
	        }
        }).catch((res) => {
            this.goodslogquery.loading=false;
        });
	},

	goodslogpageSizeChange(val) {
        this.goodslogquery.rollpage = val;
        this.getgoodslogs();
    },
    goodslogpageCurrentChange(val) {
        this.goodslogquery.p = val;
        this.getgoodslogs();
    },

	/** 获取品牌销售统计 **/
	brandlogs() {
		this.brandlogDialog=true;
		this.brandlogquery.ordertype=1;
		this.brandlogquery.sort=2;
		this.brandlogquery.key='';
		this.brandlogquery.p=1;
		this.brandlogquery.rollpage=10;
		this.getbrandlogs();
	},

	getbrandlogs() {
		if(this.isbrandchange) {
			this.brandlogquery.p=1;
			this.brandlogquery.rollpage=10;
		}

		this.brandlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.brandlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.brandlogquery.loading=false;
	        }else{
				this.brandlogquery.loading=false;
				this.brandloglists=[];
				this.brandloglists = JSON.parse(Base64.decode(res.data.Data));
				this.brand_total_rows=parseInt(res.data.count);
				if(this.isbrandchange) this.isbrandchange=false;
	        }
        }).catch((res) => {
            this.brandlogquery.loading=false;
        });
	},

	brandlogpageSizeChange(val) {
        this.brandlogquery.rollpage = val;
        this.getbrandlogs();
    },
    brandlogpageCurrentChange(val) {
        this.brandlogquery.p = val;
        this.getbrandlogs();
    },


	//获取客户统计信息
    getcustano() {
    	this.custnaoLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.shopstatviewquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.custnaoLoading=false;
            }else{
            	var _this=this;
                var result = JSON.parse(Base64.decode(res.data.Data));
				if(this.shopstatviewquery.type==1) {
					this.brand.legend.data[0]='采购金额';
					this.brand.series[0].name="采购金额";
				}
				if(this.shopstatviewquery.type==2) {
					this.brand.legend.data[0]='采购订单数量';
					this.brand.series[0].name="采购订单数量";
				}
                this.brand.xAxis.data=result.time; //时间段
                this.brand.series[0].data=result.data;                            
                this.custnaoLoading=false;
            }
        }).catch((res) => {
            this.custnaoLoading=false;
        });
    },


	/** 切换查询时间类型 **/
	changetimetype() {
		if(this.shopstatviewquery.type==2) {
			this.shopstatviewquery.stime=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1);
			this.shopstatviewquery.etime=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+12);

		}else if(this.shopstatviewquery.type==1) {
			this.shopstatviewquery.stime=new Date().getFullYear().toString();
			this.shopstatviewquery.etime=new Date().getFullYear().toString();

		}else if(this.shopstatviewquery.type==3) {
			

		}
	},

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shop-sale-table {padding:1% 1% 1% 1% !important;}
.shop-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.shop-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.shop-sale-table table .shoptitle {background:rgb(221,221,221,.3);font-weight:600}
.shop-sales-title {width:100%;font-size:13px;color:#606266;margin-bottom:10px;}
.brand {width:100%;height:300px;margin-top:10px}
</style>


// WEBPACK FOOTER //
// src/components/mall/mallsalesreplacedetail.vue